
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'FooterModal'
})
export default class FooterModal extends Vue {
  @Prop() sendNotification!: boolean;

  activityComments = '';
  checkSelected = [];

  get checkBoxOptions() {
    return [{ text: 'Solicitar documento', value: 'requestDocument' }];
  }
}
